
// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  USER_COMPANY_SHOW_FORM,
} from './constants';

export function companyShowForm(visible,type) {
  return {
    type: USER_COMPANY_SHOW_FORM,
    data:{visible,type}
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case USER_COMPANY_SHOW_FORM:
      return {
        ...state,
        userModalVisible:action.data.visible,
        userCompany:action.data.type
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/user/redux/companyShowForm.js